class SectionRenderer {
  static #getNewDomContent(contentStr) {
    return new DOMParser().parseFromString(contentStr, "text/html");
  }

  static render(sectionId, sectionContentStr) {
    const content = this.#getNewDomContent(sectionContentStr);

    const previousNode = document.querySelector(sectionId);
    const newNode = content.querySelector(sectionId);

    if (newNode) {
      previousNode.innerHTML = newNode.innerHTML;
    } else {
      previousNode.remove();
    }
  }
}
